export default function getEarnOrderPartnerships(partnerships: Array<App.Partnership>): Array<App.Partnership> {
  return partnerships?.filter((x: App.Partnership) => x.prefix !== 'cvp' && x.prefix !== 'vff');
}
